import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const OfficePage = () => (
  <Layout>
    <SEO title="Invoice online" />
    <div class="masthead-followup row m-0">
<div class="col-12 col-md-12 p-3 p-md-5 bg-white text-center">
    <h1><a title="aplikasi office bisnis" href="/office">Aplikasi Office</a></h1>
    <h2>Aplikasi invoice inventori online office.</h2>
    <div class="embed-responsive embed-responsive-21by9">
    <iframe title="aplikasi invoice inventori online" class="rounded shadow" width="560" height="315" src="https://www.youtube.com/embed/1EXPj8tkKzI" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>
    <p>Boosterpos selain develope boosterpos solutions app juga menyediakan berbagai aplikasi office untuk kebutuhan inventori invoice dan accounting akuntansi online offline, daftar list <a title="aplikasi invoice online inventori akuntansi" href="/office">aplikasi office bisnis</a>.</p>
    <hr/>
    <p>Next Invoice</p>
<img alt="aplikasi invoice online dengan tender project agenda" class="img-fluid rounded shadow" src="./img/invoicepenjualan.png"/>
<p>Aplikasi invoice online dengan pencatatan tender project agenda serta penerbitan faktur penjualan hingga faktur pajak penjualan dengan kompleks system payment mode , laporan laporan detail.</p>
<a class="button" href="./img/next invoice online generation.pdf">Download</a> <a class="button" href="https://www.youtube.com/watch?v=Dw3m1CcacCo" target="blank">Video</a>
</div>
<div class="col-12 col-md-6 p-3 p-md-5 bg-white text-left">
<p>Simple Management</p>
<img alt="aplikasi invoice inventori online" class="img-fluid rounded shadow" src="./img/PROGRAM INVOICE,SOFTWARE INVOICE DAN ACCOUNTING (3).jpg"/>
<p>Simple management berbasis online mode dengan dual based inventori dan invoice memudahkan per divisi untuk melakukan pekerjaan masing masing untuk berbagai aktivitas pembukuan nya.</p>
<a class="button" href="./img/SIMPLE MANAGEMENT APP.pdf">Download</a> <a class="button" href="https://www.youtube.com/watch?v=ImZHiYcKM7k" target="blank">Video</a>
</div>
<div class="col-12 col-md-6 p-3 p-md-5 bg-white text-left">
<p>Digital accounting</p>
<img alt="aplikasi akuntansi accounting online" class="img-fluid rounded shadow" src="./img/PROGRAM INVOICE,SOFTWARE INVOICE DAN ACCOUNTING (1).jpg"/>
<p>Software akuntasi program accounting digital untuk kebutuhan perusahaan dengan kebutuhan kompleks dan manufakturing dalam kebutuhan pembukuan detail dan terperinci hingga akuntansi nya.</p>
<a class="button" href="./img/digital Accounting.pdf">Download</a> <a class="button" href="https://www.youtube.com/playlist?list=PLQDm6k9_HvYPFF_0_BXbsei6UIcp8cMXh" target="blank">Video</a>
</div>
<div class="col-12 p-3 md-5 text-center">
<p>Itu lah daftar <a href="/toko" title="aplikasi bisnis">aplikasi office bisnis online</a> dan offline untuk digunakan pada berbagai bidang usaha , back to <Link to="/">Home Page</Link></p>
</div>
</div>
  </Layout>
)

export default OfficePage
